import React, { useEffect, useRef } from 'react';
import './AR-slot.scss';
import ARUtil from '../../utils/AR.util';
import Util from '../../utils/util';

function ARSlot({ isIntroVisible, slotMarkup, experienceURLConfig, analytics, onARBannerClick }) {

    const rootElementRef = useRef(null);

    const lang = Util.getSelectedLanguage();

    const ARBannerClickHandler = () => {

        onARBannerClick && onARBannerClick();
        if (analytics.click) {
            dataLayer.push(analytics.click);
        }

        const urlToRedirect = ARUtil.generateARExperienceLink(experienceURLConfig);
        Util.openNewTab(urlToRedirect);
    }

    useEffect(() => {

        if (rootElementRef && rootElementRef.current) {
            rootElementRef.current.addEventListener('click', ARBannerClickHandler);
        }

        return () => rootElementRef.current.removeEventListener('click', ARBannerClickHandler);

    }, [])

    return (
        <div className='ar-slot-wrapper' ref={rootElementRef} aria-hidden={isIntroVisible} dangerouslySetInnerHTML={{__html: slotMarkup[lang] || slotMarkup['en-us']}} >
        </div>
    );
}

export default ARSlot;